/* focusable.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2hGPVj98eZ%3Afocus%3Anot(%3Afocus-visible)%7Boutline-color%3AcurrentColor%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2i3C1kYbGa%3Afocus%3Anot(%3Afocus-visible)%7Boutline-style%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2kH23qT6kp%3Afocus%3Anot(%3Afocus-visible)%7Boutline-width%3Amedium%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1ubuxoD6gn%3Afocus-visible%7Boutline-color%3Avar(--ds-border-focused%2C%232684ff)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._34b3D2vc3e%3Afocus-visible%7Boutline-offset%3Avar(--ds-border-width-focused%2C2px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1NDpvb6wH8%3Afocus-visible%7Boutline-style%3Asolid%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2wtOC9vc3e%3Afocus-visible%7Boutline-width%3Avar(--ds-border-width-focused%2C2px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40media%20screen%20and%20(-ms-high-contrast%3Aactive)%2Cscreen%20and%20(forced-colors%3Aactive)%7B._3e11vU6wH8%3Afocus-visible%7Boutline-style%3Asolid%7D._0hSAgbHZdu%3Afocus-visible%7Boutline-width%3A1px%7D%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._34b3D2ZPSy%3Afocus-visible%7Boutline-offset%3Acalc(0px%20-%20var(--ds-border-width-focused%2C%202px))%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40media%20screen%20and%20(-ms-high-contrast%3Aactive)%2Cscreen%20and%20(forced-colors%3Aactive)%7B._0aMSfYZPSy%3Afocus-visible%7Boutline-offset%3Acalc(0px%20-%20var(--ds-border-width-focused%2C%202px))%7D%7D");
import { type ComponentPropsWithoutRef, type ComponentPropsWithRef, forwardRef, type JSX, type ReactElement, type ReactNode } from 'react';
import type { BasePrimitiveProps, StyleProp } from '../components/types';
const focusRingStyles = null;
const insetFocusRingStyles = null;
type AllowedElements = Exclude<keyof JSX.IntrinsicElements, 'button' | 'a'>;
type CustomElement<P = any> = { [K in AllowedElements]: P extends JSX.IntrinsicElements[K] ? K : never }[AllowedElements];
export type FocusableProps<T extends CustomElement> = Omit<ComponentPropsWithoutRef<T>, keyof BaseFocusableProps<T> | 'className' | 'style'> & BasePrimitiveProps & StyleProp & BaseFocusableProps<T>;
type BaseFocusableProps<T extends CustomElement> = {
  /**
   * The DOM element to render as the Focusable element.
   * @default 'button'
   */
  as?: T;
  children?: ReactNode;
  /**
   * Controls whether the focus ring should be applied around or within the composed element.
   */
  isInset?: boolean;
  /**
   * Forwarded ref.
   */
  ref?: ComponentPropsWithRef<T>['ref'];
};
type FocusableComponent = <T extends CustomElement>(props: FocusableProps<T>) => ReactElement;

/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */
export const Focusable = (forwardRef(<T extends CustomElement,>({
  as: Component = ('button' as T),
  children,
  isInset,
  testId,
  style,
  xcss,
  ...htmlAttributes
}: FocusableProps<T>, ref: FocusableProps<T>['ref']) => {
  // This is to remove className from safeHtmlAttributes
  // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
  const {
    className: _spreadClass,
    ...safeHtmlAttributes
  } = htmlAttributes;
  return <Component {...safeHtmlAttributes}
  // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
  ref={ref} className={ax(["_2hGPVj98eZ _2i3C1kYbGa _2kH23qT6kp _1ubuxoD6gn _34b3D2vc3e _1NDpvb6wH8 _2wtOC9vc3e _3e11vU6wH8 _0hSAgbHZdu", isInset && "_34b3D2ZPSy _0aMSfYZPSy", xcss])} style={style} data-testid={testId}>
				{children}
			</Component>;
}) as FocusableComponent);